// ** React Imports
import { ReactNode } from 'react'
import { IconProps } from '@iconify/react'

// ** MUI Imports
import { SvgIconProps } from '@mui/material'
import { SvgIconComponent } from 'src/@core/layouts/types'

interface UserIconProps {
  iconProps?: SvgIconProps
  icon: string | ReactNode | SvgIconComponent
}

const UserIcon = (props: any) => {
  // ** Props
  const { icon, ...iconProps } = props

  const IconTag = icon

  let styles

  /* styles = {
    color: 'red',
    fontSize: '2rem'
  } */

  // @ts-ignore
  return <IconTag {...iconProps} style={{ ...styles }} />
}

export default UserIcon
